export default __webpack_public_path__ + "static/media/no-image.e5010930.jpg";